import {
  getProjects as getProjectsService,
  createProject as createProjectService,
  updateProject as updateProjectService,
  deleteProject as deleteProjectService,
} from "services/company/projectManagement/project/projectService";
import {
  getProjectsStart,
  getProjectsSuccess,
  getProjectsFailure,
  createProjectStart,
  createProjectSuccess,
  createProjectFailure,
  updateProjectStart,
  updateProjectSuccess,
  updateProjectFailure,
  deleteProjectStart,
  deleteProjectSuccess,
  deleteProjectFailure,
} from "./projectSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all projects
export const fetchProjects = () => async (dispatch) => {
  try {
    dispatch(getProjectsStart());
    const response = await getProjectsService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getProjectsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch projects";
      dispatch(getProjectsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch projects error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch projects";
    dispatch(getProjectsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new project
export const createNewProject = (projectData) => async (dispatch) => {
  try {
    dispatch(createProjectStart());
    const response = await createProjectService(projectData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createProjectSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Project created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create project";
      dispatch(createProjectFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create project error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create project";
    dispatch(createProjectFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update a project
export const updateExistingProject =
  (projectId, projectData) => async (dispatch) => {
    try {
      dispatch(updateProjectStart());
      const response = await updateProjectService(projectId, projectData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateProjectSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Project updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to update project";
        dispatch(updateProjectFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update project error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update project";
      dispatch(updateProjectFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a project
export const deleteExistingProject = (projectId) => async (dispatch) => {
  try {
    dispatch(deleteProjectStart());
    const response = await deleteProjectService(projectId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deleteProjectSuccess(projectId));
      showSuccessToast(
        response?.meta?.message || "Project deleted successfully!",
      );
      return { success: true };
    } else {
      const errorMsg = response?.meta?.message || "Failed to delete project";
      dispatch(deleteProjectFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete project error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to delete project";
    dispatch(deleteProjectFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
